import Cookies from 'js-cookie';
import appConfig from '../../utils/appConfig';
import tracker from 'src/libs/tracker';

const trackInvalidInput = (relevantErrors) => {
  Object.entries(relevantErrors).forEach(([
    inputName,
    [errorMessage]
  ]) => {
    tracker.trackBabbelTracker('lead_funnel:registration:failure', 5, {
      flow_id: appConfig.getFlowId(),
      flow_version: appConfig.getFlowVersion(),
      tracking_uuid: Cookies.get('babbeltrackinguuid'),
      validation_input: inputName,
      validation_message: errorMessage
    });
  });
};

const trackSuccessRegistration = (uuid) => {
  tracker.trackBabbelTracker('lead_funnel:registered', 4, {
    flow_id: appConfig.getFlowId(),
    tracking_uuid: Cookies.get('babbeltrackinguuid'),
    uuid
  });
};

export default {
  trackInvalidInput,
  trackSuccessRegistration
};
